import type { Href } from 'expo-router'
import type { ReactNode } from 'react'

import { Button } from '@/src/elements/button/default'
import { DonationButton } from '@/src/elements/button/donation/DonationButton'
import { Header } from '@/src/elements/header'
import { DONATION_SOURCE } from '@/src/features/donation/api/types/donation'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useTranslate } from '@/src/lang/useTranslate'

type TBasicHeaderProps = {
  goBackTo: Href
}

export const BasicHeader = ({ goBackTo }: TBasicHeaderProps): ReactNode => {
  const { t } = useTranslate()
  const { handleBackPress } = useBackHandlePress(goBackTo)
  return (
    <Header
      leftButtons={[
        {
          type: 'button',
          component: () => (
            <Button
              isIconOnly
              testID={TEST_ID.HEADER.BACK_BUTTON}
              startIcon={ICON.ARROW_LEFT}
              onPress={handleBackPress}
              colors="primary"
              variant="faded"
              aria-label={t('app.how-to.open-menu')}
            />
          ),
        },
      ]}
      rightButtons={[
        {
          type: 'button',
          component: () => <DonationButton donationSource={DONATION_SOURCE.HEADER} isIconOnly />,
        },
      ]}
      className="absolute bottom-0 left-0 right-0 z-10 translate-y-full"
    />
  )
}
